import { RightOutlined } from '@ant-design/icons'
import { DriveFolderUpload, EventNote } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import ENGNoteImage from "../../assets/svg/Rectangle 3463266.svg"
import "./ServicesNotes.css"
import { Camera, Image, VideoIcon } from 'lucide-react'

const ServicesNotes = () => {
        const [showUploadModal, setShowUploadModal] = useState(false)
    
       const handleUploadShowModal = () =>{
        setShowUploadModal(true)
    }
    const handleUploadCloseModal = () =>{
        setShowUploadModal(false)
    }
  return (
   <>
     <Modal show={showUploadModal} onHide={handleUploadCloseModal} dialogClassName=''>
                    <Modal.Header closeButton>
                        <Modal.Title className=' text-center m-0'>
                       اضافة ملف
    
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{direction:"rtl"}}>
                      <div className="d-flex align-items-center gap-4 p-3">
                        <input type="file" className='d-none' id="upload-file" />
                        <label htmlFor="upload-file"><div className="text-center cursor">
                            <div style={{border:"1px solid #C6C6C6" ,borderRadius:"50%"}} className=' p-3 d-flex justify-content-center my-1'>
                              <Image  className='main-text-color'/>
                            </div>
                            <p>ملفاتي</p>
                        </div></label>
                        
                      
                              <div className="text-center">
                            <div style={{border:"1px solid #C6C6C6" ,borderRadius:"50%"}} className=' p-3 d-flex justify-content-center my-1'>
                              <Camera  className='main-text-color'/>
                            </div>
                            <p>كاميرا</p>
                        </div>
                    
                         <div className="text-center">
                            <div style={{border:"1px solid #C6C6C6" ,borderRadius:"50%"}} className=' p-3 d-flex justify-content-center my-1'>
                              <VideoIcon  className='main-text-color'/>
                            </div>
                            <p>فيديو</p>
                        </div>
    
                      </div>
                    </Modal.Body>
                </Modal>
    <div style={{direction:"rtl"}} className='min-vh-100 m-4'>
      <div className="d-flex justify-content-between align-items-center">
          <h4  className='fw-bold  m-0'>
                        ملاحظات ومرفقات الخدمة – تغيير الزيت
                    </h4>
      </div>
        <div className='my-3'>
                        <h6 style={{ color: "#535353" }}>ملاحظة الفني:</h6>
                        <p className='fw-semibold fs-5'>لاحظت أن الفلتر القديم كان فيه تهريب خفيف وركبنا جديد مكانه.</p>
                    </div>
                    <div className='my-3'>
                        <h6 style={{ color: "#535353" }}>الصور المرفقة:</h6>
                        <div className="w-100 d-flex justify-content-center">
                        <img className='w-50' src={ENGNoteImage} alt="Note-image" />

                        </div>
                    </div>
                    <div className='my-4'>
                        <p>اكتب ملاحظة أو ارفع صورة للجزء في حالة وجود مشكله</p>
                        <textarea style={{ padding: 10, borderRadius: 10, border: "solid 2px #D8D8D8", }} rows={5} className='w-100' placeholder='اكتب أي ملاحظات عن هذا الجزء...' id=""></textarea>
                    </div>
                    <div className='my-3'>
                        <p>ارفع صورة توضح حالة الجزء</p>
                        <div style={{border:"2px dashed #C6C6C6"}} className="p-4 w-100 rounded-3 d-flex justify-content-center align-items-center"
                        
                        >
                            <div onClick={handleUploadShowModal} className='text-center'>
                                <DriveFolderUpload sx={{fontSize:"50px",color:"#535353"}}/>
                                <p style={{color:"#535353",margin:0}}>اضف ملف </p>
                                <p style={{color:"#828282",margin:0}}>أرفق صورة، فيديو، أو تسجيل صوتي.</p>
                            </div>
                        </div>

                    </div>
    </div>
   </>
  )
}

export default ServicesNotes